import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Product2, ProductWorkflow, ProductTransition, WorkflowStateType, ProductWorkflowTrigger } from 'situview-webapi-client';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ConfigService } from 'src/app/services/config.service';

@Component({
  selector: 'workflow-trigger-dialog',
  templateUrl: './workflow-trigger-dialog.component.html',
  styleUrls: ['./workflow-trigger-dialog.component.scss']
})
export class WorkflowTriggerDialogComponent {

  selectedTransition?: ProductTransition;
  comments?: string;

  triggerInvalidReason?: string;

  workflowStateType = WorkflowStateType;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: WorkflowTriggerDialogData,
    private dialogRef: MatDialogRef<WorkflowTriggerDialogData>) {
      
  }

  async onRunTrigger() {

    // See if there is any pre trigger steps that is required first
    if (this.data.preWorkflowTriggerSteps) {

      for (var preTriggerStep of this.data.preWorkflowTriggerSteps) {

        if (this.selectedTransition?.requiredProperties?.some(x => x === preTriggerStep.requiredProperty)) {

          if (preTriggerStep.shouldRun === undefined || preTriggerStep.shouldRun()) {
            var success = await preTriggerStep.preTriggerFunction();
            if (!success) {
              // The pre trigger failed, don't continue 
              return;
            }
          }

        }

      }

    }

    this.dialogRef.close(this.getReturnData());
  }

  shouldShowTransition(transition: ProductTransition): boolean {
    // allow the transition if there are pre trigger steps setup to satisfy the required properties

    if (!this.data.preWorkflowTriggerSteps || !this.data.workflowSubject) {
      return false;
    }

    for (var requiredProperty of transition.requiredProperties!) {
      if ((this.data.workflowSubject[requiredProperty] === undefined || this.data.workflowSubject[requiredProperty] === null) &&
        !this.data.preWorkflowTriggerSteps.some(e => e.requiredProperty === requiredProperty))
      {
        // This property has not been set, and
        // there is no pre trigger step that could fill out this missing required property
        return false
      }
    }

    return true;

  }

  triggerIsValid(): boolean {
    if (!this.selectedTransition) {
      return !!this.comments;
    }
    
    if (this.selectedTransition.requiresWorkflowComments && !this.comments) {
      this.triggerInvalidReason = "Comments are required."
      return false;
    }

    this.triggerInvalidReason = undefined;
    return true;
  }

  nagivateBack() {
    this.dialogRef.close();
  }

  getReturnData(): WorkflowTriggerResultData {
    return { 
      selectedTransition: this.selectedTransition,
      comments: this.comments,
    } as WorkflowTriggerResultData;
  }
}

export interface WorkflowTriggerDialogData {
  workflowSubject: any;
  workflowState: ProductWorkflow;
  preWorkflowTriggerSteps?: PreWorkflowTriggerStep[];
}

export interface PreWorkflowTriggerStep {
  requiredProperty: string;
  shouldRun?: () => boolean;
  preTriggerFunction: () => Promise<boolean> ;
}

export interface WorkflowTriggerResultData {
  selectedTransition: ProductTransition;
  comments?: string,
}